import React, { useEffect } from 'react';
import { Col, Row, Card, Button, Collapse, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
const ConcessionTable1 = require("../assets/original/Concession-Table-1.png");
const HalfFareConcessionRegional = require("../assets/original/Half-fare-concession-regional-1.png");
const ConcessionTable3 = require("../assets/original/Concession-table-3.png");
const ConcessionTable4 = require("../assets/original/Concession-table-4.png");

const items = [
  {
    key: '2',
    label: "Free Travel",
    children: <div><img alt="" src={ConcessionTable1} width="100%" /></div>
  },
  {
    key: '3',
    label: "Half Fare Concession & Regional Excursion Daily (RED)",
    children: <div><img alt="" src={HalfFareConcessionRegional} width="100%" /></div>
  },
  {
    key: '4',
    label: "Half Fare Concession (Ages 16 and over)",
    children: <div><img alt="" src={ConcessionTable3} width="100%" /></div>
  },
  {
    key: '5',
    label: "Half Fare (Ages 4 - 15 inclusive)",
    children: <div><img alt="" src={ConcessionTable4} width="100%" /></div>
  }
];

export default function StudentTravel() {
  useEffect(() => {
    document.body.classList.add("PageStudentTravel");
    return () => {
      document.body.classList.remove("PageStudentTravel");
    };
  }, []);
  return (
    <div className="StudentTravel PageSingle" style={{paddingBottom: "50px"}}>
      <section className="PageHero">
        <div className="AppContainer">
          <h1 className="title">Fares and Concessions</h1>
        </div>
      </section>
      <div className="AppContainer">
        <Row gutter={[20, 0]}>
          <Col xs={{span: 24, order: 2}} md={{span: 24, order: 1}}>
            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Rural and Regional Fares</h2>
              <p>There are a number of ticketing options for our customers. Bus fares are determined by the number of sections travelled for a trip. One section equals approximately 1.6km.</p>
              <p>If you know how many sections your trip entails, you can find out the cost of your bus trip by using the fare tables below.</p>
            </Card>
            <Card bordered={false} className="CardItem mb-25 ">
              <h2 className="CardTitle">Single Trip Fares</h2>
              <div className="TableWrap mb-40">
                <table width="100%" className="TableList">
                  <thead>
                  <tr>
                  <th align="left">Fare Band</th>
                  <th align="left">Sections</th>
                  <th align="left">Adult</th>
                  <th align="left">Concession</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <td align="left">1</td>
                  <td align="left">1 to 2</td>
                  <td align="left">$2.30</td>
                  <td align="left">$1.10</td>
                  </tr>
                  <tr>
                  <td align="left">2</td>
                  <td align="left">3 to 6</td>
                  <td align="left">$3.30</td>
                  <td align="left">$1.60</td>
                  </tr>
                  <tr>
                  <td align="left">3</td>
                  <td align="left">7 to 15</td>
                  <td align="left">$4.20</td>
                  <td align="left">$2.10</td>
                  </tr>
                  <tr>
                  <td align="left">4</td>
                  <td align="left">16 to 25</td>
                  <td align="left">$4.50</td>
                  <td align="left">$2.20</td>
                  </tr>
                  <tr>
                  <td align="left">5</td>
                  <td align="left">26 to 37</td>
                  <td align="left">$5.90</td>
                  <td align="left">$2.90</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="CardTitle">Daily Ticket Fares</h2>
              <div className="TableWrap">
                <table width="100%" className="TableList">
                  <thead>
                  <tr>
                  <th align="left">Fare Band</th>
                  <th align="left">Adult</th>
                  <th align="left">Concession</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <td align="left">1</td>
                  <td align="left">$5.00</td>
                  <td align="left">$2.50</td>
                  </tr>
                  <tr>
                  <td align="left">2</td>
                  <td align="left">$5.00</td>
                  <td align="left">$2.50</td>
                  </tr>
                  <tr>
                  <td align="left">3</td>
                  <td align="left">$10.00</td>
                  <td align="left">$5.00</td>
                  </tr>
                  <tr>
                  <td align="left">4</td>
                  <td align="left">$10.00</td>
                  <td align="left">$5.00</td>
                  </tr>
                  <tr>
                  <td align="left">5</td>
                  <td align="left">$10.00</td>
                  <td align="left">$5.00</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </Card>
            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Tickets</h2>
              <p className='mb-0'>Tickets can be paid for using cash only. Please assist the driver by having the correct fare or small change ready.</p>
              <p>The Opal card is not accepted on rural and regional bus services.</p>
              <p><strong>Single Ticket</strong> - One trip from the origin to the destination.</p>
              <p><strong>Return Ticket</strong> - Travel from the origin to the destination and back to the origin again.</p>
              <p><strong>Daily Ticket</strong> - Unlimited travel for the sections and fare bands purchased for that day of travel.</p>
              <p><strong>Transfer Ticket</strong> - Allow customers to transfer from one bus service to another and are a cheaper option than buying two tickets.</p>
              <p><strong>Regional Excursion Daily Ticket (RED)</strong> - Provides eligible concession card holders with unlimited daily travel within our network for just $2.50.</p>
            </Card>
            <Card bordered={false} className="CardItem">
              <h2 className="CardTitle">Concession Passes</h2>
              <Collapse accordion items={items} size="large" />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
